import { IconProps } from "../icon.types"

type Props = IconProps

export const IconFinishing = ({ size = 24, ...props }: Props) => (
  <svg
    id="finishing_svg__Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 44 44"
    xmlSpace="preserve"
    width={size}
    height={size}
    {...props}
  >
    <style>
      {
        ".finishing_svg__st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round}"
      }
    </style>
    <path
      className="finishing_svg__st0"
      d="M10.1 12.1V9M10.1 16.7v-3.1M10.9 12.9H14M6.3 12.9h3.1M33.9 22.7v-3.1M33.9 27.3v-3.1M34.7 23.5h3.1M30.1 23.5h3.1M27.7 18.9c-2-2.8-4.1-5.5-7.6-6.4-.3-.1-.5.2-.5.4-.1 5.3-6.1 5.7-8.5 8.8-.2.2 0 .6.3.6 1 .3 1.8.7 2.6 1.2 4.1 2.8 6.1 7.2 7.8 8.7l1.8 1.8c.2.2.5.1.7-.1 1.8-2.4 4.2-2.9 6.1-4.2"
    />
  </svg>
)
